import { useState } from "react";
import { steps } from "@/mocks/lawfirm";

export default function Process() {
  const [expanded, setExpanded] = useState<string | null>(null);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
            <i className="ri-route-line"></i>
            ONE-STOP PROCESS
          </p>
          <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            <span className="md:hidden">
              상담부터 집행까지,
              <br />
              <span className="text-accent-600">원스톱 프로세스</span>
            </span>
            <span className="hidden md:inline">
              상담부터 집행까지, <span className="text-accent-600">원스톱 프로세스</span>
            </span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            광주부장판사·검사출신변호사와 함께라면 복잡한 법적 절차도 걱정 없습니다.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 items-start">
          {steps.map((step) => {
            const isOpen = expanded === step.step;

            return (
              <button
                key={step.step}
                type="button"
                onClick={() => setExpanded(isOpen ? null : step.step)}
                className="group relative flex min-h-72 flex-col rounded-lg overflow-hidden text-left cursor-pointer"
              >
                <img
                  src={step.image}
                  alt={step.title}
                  title={`광주 변호사 ${step.title} 단계`}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/35 to-primary-950/10"></div>

                <div className="relative z-10 flex flex-1 flex-col justify-between p-5">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-semibold text-white/80 tracking-wider">
                      {step.step}
                    </span>
                    <span
                      className={`flex items-center justify-center w-8 h-8 rounded-full bg-white/15 text-white backdrop-blur-sm transition-colors ${
                        isOpen
                          ? "bg-accent-500 text-foreground-950"
                          : "group-hover:bg-accent-500 group-hover:text-foreground-950"
                      }`}
                    >
                      <i
                        className={`text-lg transition-transform duration-300 ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </span>
                  </div>

                  <div className="mt-4">
                    <span className="flex items-center justify-center w-10 h-10 rounded-md bg-white/15 text-accent-300 backdrop-blur-sm">
                      <i className={`${step.icon} text-lg`}></i>
                    </span>
                    <h3 className="mt-3 font-heading text-xl font-bold text-white">
                      {step.title}
                    </h3>

                    <div
                      className={`overflow-hidden transition-all duration-500 ${
                        isOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                      }`}
                    >
                      <p className="pt-3 text-sm text-white/85 leading-relaxed">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}